export default "__VITE_ASSET__DZnxx679__"